import QuizResults from './QuizResults'
import QuizIncomplete from './QuizIncomplete'
import QuizConfirmSubmit from './QuizConfirmSubmit'
import QuizHelp from './QuizHelp'

export default [
  {
    path: 'quiz-results',
    component: QuizResults,
  },
  {
    path: 'quiz-incomplete',
    component: QuizIncomplete,
  },
  {
    path: 'quiz-confirm-submit',
    component: QuizConfirmSubmit,
  },
  {
    path: 'quiz-help',
    component: QuizHelp,
  },
]
